<template>
	<div class="stage">
		<div class="stage__head">
			<img src="@/assets/Header.jpg">
		</div>
		<div class="wrapper">
			<div class="wrapper-video">
				<video class="video-case-study" poster="@/assets/Teaser-Video_1.jpg" controls preload="none" src="https://player.vimeo.com/external/334618720.hd.mp4?s=5819155a51995f1b73d28e22380cbbcb3ca02593&profile_id=175" onclick="this.paused?this.play():this.pause();">
				</video>

				<div class="controls-video">
					<div class="controls-inner-video">
						<button id="btn-play-pause" class="btn-play" title="Play/Pause video"><span><font-awesome-icon class="play-circle" icon="play-circle"></font-awesome-icon></span>case study video</button>
					</div>

					<div class="controls-outer-video">
						<div id="main-vid-progress" class="progress">
							<span class="progress-current" id="curr-progress-vid"></span>
						</div>
						<div class="time">
							<span class="current-t">00:00</span> /
							<span class="duration-t">01:48</span>
						</div>
						<button class="btn-fullscreen-main" title="Switch to fullscreen view"><span>see it fullscreen</span></button>
					</div>
				</div>
			</div>
		</div>
		<div class="stage__tiles">
			<div class="stage__tile">
				<h1 class="stage__tile-header">Problem</h1>
				<p class="stage__tile-text">
					DKMS has two problems: Statistically, their most important target group of stem cell donors are young, active me.
					But they are very tough to recruit for charity.
					<br><br>
					Secondly, the lab costs for the analysis of each sample are very expensive.
				</p>
			</div>
			<div class="stage__tile stage__tile-white">
				<h1 class="stage__tile-header header_black">Solution</h1>
				<p class="stage__tile-text">
					To solve both problems, we teamed up with Jérôme Boateng and turned the DKMS registration set into a stylish Limited Edition.
				<br><br>
					The launch campaign created massive hype on Instagram and football-related media. And through an Instagram-based webshop, the Limited Edition sold out in days - covering the costs of each analysis.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'stage',
		data() {
			return {
			}
		},
		mounted() {

			// DETECT TOUCH SUPPORT
			var isTouchCapable = 'ontouchstart' in window ||
					window.DocumentTouch && document instanceof window.DocumentTouch ||
					navigator.maxTouchPoints > 0 ||
					window.navigator.msMaxTouchPoints > 0;


			// DETECT MP4 SUPPORT
			var isMP4Capable = false;
			var v = document.createElement('video');
			if (v.canPlayType && v.canPlayType('video/mp4').replace(/no/, '')) {
				isMP4Capable = true;
			}

			if (isTouchCapable) {
				document.body.classList.add('touch-support');
			}

			if (isMP4Capable) {
				document.body.classList.add('mp4-support');
			}

			// CUSTOM HTML5 VIDEO

			if (isMP4Capable) {
				var video = document.getElementsByClassName('video-case-study');
				var controlbtn = document.getElementById('btn-play-pause');

				video[0].removeAttribute("controls");


				var playpause = function () {
					if (video[0].paused || video[0].ended) {
						controlbtn.classList.add('paused');
						video[0].play();

					} else {
						controlbtn.classList.remove('paused');
						video[0].pause();
					}
				};


				if (isTouchCapable) {
					video[0].ontouchstart = function () {
						playpause();
					};
					controlbtn.ontouchstart = function () {
						playpause();
					};
				}
				else {
					video[0].onclick = function () {
						playpause();
					};

					controlbtn.onclick = function () {
						playpause();
					};
				}

				//video ended event
				video[0].onended = function () {
					controlbtn.classList.add('paused');
					video[0].pause();
				};

				//fullscreen button clicked change the controld
				var btnFullScreen  =  document.getElementsByClassName('btn-fullscreen-main');
				btnFullScreen[0].onclick = function () {
					if (typeof (video[0].webkitEnterFullscreen) === 'function') {
						video[0].webkitEnterFullscreen();
					} else if (typeof (video[0].mozRequestFullScreen) === 'function') {
						video[0].mozRequestFullScreen();
					} else {
						alert('Your browsers doesn\'t support fullscreen');
					}
				};

				var progress = document.getElementById('main-vid-progress');
				var currProgress = document.getElementById('curr-progress-vid');


				var updatebar = function (x) {

					var maxduration = video[0].duration;
					var position = x - progress.offsetLeft;
					var percentage = 100 * position / progress.offsetWidth;
					if (percentage > 100) {
						percentage = 100;
					}
					if (percentage < 0) {
						percentage = 0;
					}

					currProgress.style.width = percentage + '%';
					video[0].currentTime = maxduration * percentage / 100;
				};

				var timeDrag = false; /* check for drag event */
				progress.addEventListener('mousedown', function (e) {
					timeDrag = true;
					updatebar(e.pageX);
				});

				window.addEventListener('mouseup', function (e) {
					if (timeDrag) {
						timeDrag = false;
						updatebar(e.pageX);
					}
				});

				window.addEventListener('mousemove', function (e) {
					if (timeDrag) {
						updatebar(e.pageX);
					}
				});

				var timeFormat = function (seconds) {
					var m = Math.floor(seconds / 60) < 10 ? "0" + Math.floor(seconds / 60) : Math.floor(seconds / 60);
					var s = Math.floor(seconds - (m * 60)) < 10 ? "0" + Math.floor(seconds - (m * 60)) : Math.floor(seconds - (m * 60));
					return m + ":" + s;
				};

				// display current video play time
				var curr = document.getElementsByClassName('current-t');
				var duration = document.getElementsByClassName('duration-t');

				video[0].ontimeupdate = function () {
					var currentPos = video[0].currentTime;
					var maxduration = video[0].duration;
					var perc = 100 * currentPos / maxduration;
					currProgress.style.width = perc + '%';
					curr[0].innerHTML = timeFormat(currentPos);
				};

				video[0].onloadedmetadata = function () {
					curr[0].innerHTML = timeFormat(0);
					duration[0].innerHTML = timeFormat(video[0].duration);
				};
			}
			else {
				document.getElementsByClassName('wrapper-video').appendChild('<iframe src="https://player.vimeo.com/video/334618720" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>');
			}

		},
		methods: {

		},
    }
</script>

<style lang="scss" scoped>

	.stage__head {
		position: relative;
		width: 100%;
		height: 100%;
		text-align: center;
		display: block;
		padding-bottom: 5%;

		img {
			width: 91%;
            padding-top: 5%;
			@media screen and (max-width: 768px) {
				width: 100%;
			}
		}
	}


	.stage__tiles {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: flex-start;
		align-items: stretch;
		padding-top: 7%;

		@media screen and (min-width: 768px) {
			padding-top: 5%;
			flex-wrap: nowrap;
		}
	}

	.stage__tile {
		flex-basis: 100%;
		min-height: 40vw;
		background-color: #000;
		text-align: center;
		line-height: 2em;
		padding: 10%;
		vertical-align: bottom;
		color: #fff;
		padding: 20% 15% 10% 15%;

			@media screen and (min-width: 768px) {
				min-height: 30vw;
				color: #fff;
				padding: 10% 10% 5% 10%;
			}


		&-white {
			background-color: #fff;
			color: #303030;

			.header_black {
				color: #000;
			}
		}

		&-header {
			font-family: dkms1;
			text-transform: uppercase;
			margin-bottom: 10%;
			font-size: 2.7rem;
			letter-spacing: 1px;

			@media screen and (max-width: 768px) {
				font-size: 2.2rem;
				letter-spacing: 1px;
			}

		}

		&-text {
          font-size: 1.2rem;

			@media screen and (max-width: 768px) {
				font-size: 1rem;
			}
		}


	}

	.wrapper {
		margin: 0 auto;
		position: relative;
		max-width: 90vw;

		@media screen and (max-width: 768px) {
			max-width: 100vw;
		}
	}


	body:not(.mp4-support) .wrapper-video {
		padding-top: 56.25%;
	}

	.wrapper-video {
		position: relative;
	}

	video {
		width: 100%;
		outline:none;
	}

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border: none;
	}

	body:not(.mp4-support) .controls-video,
	body:not(.mp4-support) video {
		display: none;
	}

	body:not(.touch-support) .btn-play:hover {
		transform: scale(1.2) translate(-40%,-40%);
	}


	.controls-inner-video {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		padding-top: 56.25%;
		pointer-events: none;
	}

	.btn-play {
		opacity: 1;
		pointer-events: all;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		transition: opacity 0.3s, transform 0.3s;
		-moz-transition: opacity 0.3s, transform 0.3s;
		-webkit-transition: opacity 0.3s, transform 0.3s;
		-o-transition: opacity 0.3s, transform 0.3s;
		border: none;
		background: none;
		padding: 1% 5%;
		margin: 0;
		cursor: pointer;
		outline: none;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		-webkit-tap-highlight-color: transparent;
		padding: 1% 5%;
		background: #fff;
		text-transform: uppercase;
		font-family: dkms1;
		font-size: 2.7rem;
		color: #5D402F;

		@media screen and (max-width: 1024px) {
			font-size: 2rem;
		}

		@media screen and (max-width: 767px) {
			font-size: 1rem;
		}

		@media screen and (max-width: 560px) {
			font-size: .9rem;
		}

		svg {
			font-size: 2.5rem;
			right: 3%;
			position: relative;


			@media screen and (max-width: 1024px) {
				font-size: 1.8rem;

			}

			@media screen and (max-width: 767px) {
				font-size: .8rem;

			}


		}
	}

	.btn-fullscreen-main {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: flex-start;
		align-items: stretch;
		background-color: #999999;
		padding: 1% 5%;
		margin-top: 1.7%;
		cursor: pointer;
		outline: none;
		text-transform: uppercase;
		font-family: dkms1;
		font-size: .9rem;
		letter-spacing: 1px;
		color: #fff;
		border: 4px solid !important;
		border-color: transparent;
		&:hover {
			color: #999 !important;
			background: transparent;
			border: 4px solid #999 !important;
			transition: all 0.4s ease 0s;
		}

			@media screen and (min-width: 768px) {
				flex-wrap: nowrap;
				font-size: 1.4rem;
			}
	}

	.paused  {
		opacity: 0;
		pointer-events: none;
	}


	.progress {
		margin-top: 1%;
		width: 100%;
		height: 2px;
		position:relative;
		cursor:pointer;
		background: #DDD;
	}

	.progress span {
		height:100%;
		position:absolute;
		top:0;
		left:0;
		display:block;
	}

	.progress-current {
		z-index: 10;
		width: 0;
		background: #5D402F;
	}

	.time {
		margin-top: 1%;
		float: right;
		text-align: center;
		font-size: .8rem;

			@media screen and (max-width: 768px) {
				margin: 2%;
			}
	}

</style>
